module.exports = __webpack_public_path__ + "img/img-7dc514.png";